import { TECHNOLOGIES } from "@constants/global.constants";

export const SPECIES_UNIT_MICROGRAM_LITRE = 1;

export const AMBERLITE_62_I_ID = 163;

export const protocolNumber = {
  protocolOne: 1,
  protocolTwo: 2,
};

export const selectedResinList = [
  {
    ixResinID1: 0,
    inert: null,
    ixResinID2: 0,
    ionicFormSelected_ind: false,
    columnNo: 1,
    defaultPackagingSize: 0,
  },
  {
    ixResinID1: 0,
    inert: null,
    ixResinID2: 0,
    ionicFormSelected_ind: true,
    columnNo: 2,
    defaultPackagingSize: 0,
  },
  {
    ixResinID1: 0,
    inert: null,
    ixResinID2: 0,
    ionicFormSelected_ind: false,
    columnNo: 3,
    defaultPackagingSize: 0,
  },
];

export const waterTreatmentProcesses = {
  pretreatement: [TECHNOLOGIES.UF, TECHNOLOGIES.IXSD, TECHNOLOGIES.IXOS],
  bulkdemineralization: [TECHNOLOGIES.RO, TECHNOLOGIES.CCRO, TECHNOLOGIES.IXD],
  trace: [TECHNOLOGIES.IXN, TECHNOLOGIES.IXB],
  posilishing: [TECHNOLOGIES.IXMB, TECHNOLOGIES.IXCP],
};

export const FINAL_PARAMETER_LIST = {
  resinType: "final",
  resinId: 0,
  vesselNo: 0,
  resinVolumeAsDelivered: 0,
  vesselDiameter: 0,
  resinBedHeightAsDelivered: 0,
  resinBedStandardHeight: 0,
  resinBedHeightAsExhausted: 0,
  resinBedHeightAsRegenerated: 0,
  inertResinVolume: 0,
  inertBedHeight: 0,
  vesselCylindricalHeight: 0,
  vesselWallThickness: 0,
  pressureDropwithRecomQty: 0,
  resinPackagingSize: 0,
  ixfpaRadioButtonID: 0,
};
export const SIO2_MASS_MILLI = 60.08433;

export const SIO2_MASS_MICRO = 60084.33;

export const WATER_BLOCK_ID = 5;

export const BW_SOURCE_IXMB = 1;

export const SAC_SAFETY_FACTOR = "SAC Safety Factor";
export const WAC_SAFETY_FACTOR = "WAC Safety Factor";
export const SBA_SAFETY_FACTOR = "SBA Safety Factor";
export const WBA_SAFETY_FACTOR = "WBA Safety Factor";
export const WAC_OVERRUN = "WAC Overrun";
export const WBA_OVERRUN = "WBA Overrun";
export const REGENERATION_RATIO = "Regeneration Ratio";

export const DEFAULT_REGENERANT_DOSE_VAL3 = 100;

export const WAC_RESIN_ID = 3;
export const WBA_RESIN_ID = 4;
export const REGENERANT_DOSE_ID = 1;
export const REGENERANT_RATIO = 4;

export const IX_DEGAS_DEFAULTS = {
  co2Removal: 50,
  co2PartialPressure: 400,
  co2Concentration: 10,
};

export const RESIN_ID = {
  WAC_RESIN_ID: 3,
  WBA_RESIN_ID: 4,
  SAC_RESIN_ID: 2,
  SBA_RESIN_ID: 1,
  WAC_SAC_TWO_VESSEL_RESIN_ID: 5,
  WBA_SBA_TWO_VESSEL_RESIN_ID: 11,
  WAC_SAC_TWO_CHAMBER_RESIN_ID: 7,
  WBA_SBA_TWO_CHAMBER_RESIN_ID: 13,
  WAC_SAC_SINGLE_CHAMBER_RESIN_ID: 6,
  WBA_SBA_SINGLE_CHAMBER_RESIN_ID: 12,
  SBA_SAC_SINGLE_CHAMBER_RESIN_ID: 9,
  SBA_SAC_TWO_CHAMBER_RESIN_ID: 10,
  INERT_NONE_ID: 0,
  SAC_SBA_TWO_VESSEL_RESIN_ID: 8,
  SAC_SAC_SBA_TWO_VESSEL_RESIN_ID: 14,
  SAC_SBA_SAC_THREE_VESSEL_RESIN_ID: 15,
};

export const RESIN_MAPPINGS_BY_ID = {
  [RESIN_ID.SBA_RESIN_ID]: "[SBA]",
  [RESIN_ID.SAC_RESIN_ID]: "[SAC]",
  [RESIN_ID.WAC_RESIN_ID]: "[WAC]",
  [RESIN_ID.WBA_RESIN_ID]: "[WBA]",
  [RESIN_ID.WAC_SAC_TWO_VESSEL_RESIN_ID]: "[WAC] - [SAC]",
  [RESIN_ID.WAC_SAC_SINGLE_CHAMBER_RESIN_ID]: "[WAC SAC]",
  [RESIN_ID.WAC_SAC_TWO_CHAMBER_RESIN_ID]: "[WAC | SAC]",
  [RESIN_ID.SBA_SAC_SINGLE_CHAMBER_RESIN_ID]: "[SAC SBA]",
  [RESIN_ID.SBA_SAC_TWO_CHAMBER_RESIN_ID]: "[SAC | SBA]",
  [RESIN_ID.WBA_SBA_TWO_VESSEL_RESIN_ID]: "[WBA] - [SBA]",
  [RESIN_ID.WBA_SBA_SINGLE_CHAMBER_RESIN_ID]: "[WBA SBA]",
  [RESIN_ID.WBA_SBA_TWO_CHAMBER_RESIN_ID]: "[WBA | SBA]",
  [RESIN_ID.SAC_SBA_TWO_VESSEL_RESIN_ID]: "[SAC] - [SBA]",
  [RESIN_ID.SAC_SAC_SBA_TWO_VESSEL_RESIN_ID]: "[SAC] - [SAC SBA]",
  [RESIN_ID.SAC_SBA_SAC_THREE_VESSEL_RESIN_ID]: "[SAC] - [SBA] - [SAC]",
};

// 1, 4, 11, 12, 13
export const HARDNESS_ANIONS_RESIN_ID = [
  RESIN_ID.SBA_RESIN_ID,
  RESIN_ID.WBA_RESIN_ID,
  RESIN_ID.WBA_SBA_TWO_VESSEL_RESIN_ID,
  RESIN_ID.WBA_SBA_SINGLE_CHAMBER_RESIN_ID,
  RESIN_ID.WBA_SBA_TWO_CHAMBER_RESIN_ID,
];

export const HARDNESS_CATIONS_RESIN_ID = [RESIN_ID.WAC_RESIN_ID];

export const VESSEL_ID = {
  WATER_BLOCK_ID: 5,
  AIR_BLOCK_ID: 4,
  COCURRENT_ID: 0,
  AMBERPACK_ID: 2,
  MB_INTERNAL_ID: 8,
  MB_EXTERNAL_ID: 9,
  UPCORE_ID: 1,
};

export const CHEMICAL_NAMES = {
  CHLORINE: "Cl",
  HYDRO_OXIDE: "OH",
  SODIUM: "Na",
  HYDROGEN: "H",
  SULPHATE: "SO4",
};

export const MODELLING_OBJECTIVE = {
  NEW_PLANT: "NEW_PLANT",
  EXISTING_PLANT: "EXISTING_PLANT",
};

export const AMBERLITE_600I_Inert_ID = 162;
export const AMBERLITE_14I_Inert_ID = 161;

export const IX_RESINID = {
  AmberLite_HPR1200_H: 165,
  AmberLite_HPR1300_H: 167,
  AmberLite_HPR4700_OH: 181,
  AmberLite_HPR4700_Cl: 180,
  AmberLite_HPR4800_Cl: 183,
  AmberLite_HPR8300_H: 191,
  AmberLite_HPR9500: 198,
  AmberLite_PWA10: 44,
};

export const IXD_STRING = {
  CATION: "cation",
  ANION: "anion",
  BACKWASH: "backwash",
  SERVICE_WATER: "serviceWater",
  IX_RESINID_2: "ixResinID2",
  SBA: "SBA",
  SAC: "SAC",
  INERT: "inert",
  IONIC_FORM_SELECTED_IND: "ionicFormSelected_ind",
};

export const IXInitializationRanges = {
  operatingCycle_Lenght_txtInDays: {
    min: 3,
    max: 2400,
  },
  operatingCycle_Lenght_txt: {
    min: 0.125,
    max: 100,
  },
  bypassed: {
    min: 0,
    max: 95,
  },
  trains_Online: {
    min: 1,
    max: 20,
  },
  trains_StandBy: {
    min: 0,
    min_train_online: 1,
    max: 5,
  },
};

export const SPECIES_LABEL_ID = {
  conductivityLbaleID: 2,
  anionSpeciesLabelID: 4,
};

export const REGENERATION_RATIO_RANGE = {
  min: 100,
  max: 10000,
};

// WBA, WAC, SBA, SAC
export const SAFETY_FACTOR_RANGE = {
  min: 0.001,
  max: 2.0,
};

export const OverallProcessType = {
  Demineralization: 7,
  IX_Demin_Polishing: 11,
  RO_Permeate_Polishing: 10,
  IX_Nitrate_Removal: 8,
  IX_Boron_Removal: 9,
  IX_Organic_Scavenger: 0,
  IX_Process_HOH_Cycle: 12,
  IX_Low_Pressure_Power_HOH_Cycle: 13,
  IX_High_Pressure_Power_HOH_Cycle: 14,
};

export const CHECMICAL_VALUES_REGENRANT = {
  H2SO4: 2,
};
export const ALERT_MSG = {
  RESIN_ARRANGEMENT_CHANGE:
    "You are about to switch the process. Do you still want to proceed? <br> Hint : Try adding another case, if you want to compare.",
  EFFLUENT_QUALITY_CATION_CHANGE:
    "The Na Average Leakage value is larger than the Endpoint value. Please revise your input.",
  EFFLUENT_QUALITY_ANION_CHANGE:
    "The SiO₂ Average Leakage value is larger than the Endpoint value. Please revise your input.",
  DOSE_FRAC_VALIDATION: "The sum of dose fractions should be 100%",
  CO2_PRESSURE_VALIDATION: (min, max) =>
    `The IX Degasification Effluent Partial Pressure is not correctly specified. It should be between ${min} and ${max}`,
  REGEN_SV_VALIDATION:
    "The flow rate value you have entered is not compatible with the resin volume. Please revise your inputs to continue",
  EXISTING_REGEN_VALIDATION: "The Existing Regeneration Conditions is not correctly specified",
  PRODUCT_QUALITY_VALIDATION: "The Product Quality & Regenerant Dose is not correctly specified",
  IX_INITIALZATION_VALIDATION: "The IX Initialization is not correctly specified",
  IX_ADVANCED_REGENERATION: "The IX Advanced Regeneration is not correctly specified",
  IX_EXISTING_PLANT: "The IX Existing Plant is not correctly specified",
  IX_FINAL_PARAMETER_ADJUSTMENT: "The IX Final Parameter Adjustment is not correctly specified",
  IX_EQUIPMENT: "The IX Equipment is not correctly specified",
  IX_VESSEL_REGENERATION: "The IX Vessel and Regeneration system is not correctly specified",
};

export const CONDUCTIVITY_INIT_VAL = {
  vesselCoCurrentAvg: 1.08,
  vesselCoCurrentEnd: 2.15,
  vesselOthersAvg: 0.22,
  vesselOthersEnd: 0.43,
};

export const IXD_DESIGN_FPA = {
  EVALUATE_DESIGN: 1,
  RETROFIT_DESIGN: 2,
};

export const EffluentQulatiyRanges = {
  Average: {
    min: 0.46,
    max: 4600000,
  },
  EndPoint: {
    min: 0.46,
    max: 4600000,
  },
};

export const SERVICE_WATER = {
  CATION_BW_FW: 0,
  CATION_BW_DW: 2,
  ANION_BW_FW: 0,
  ANION_BW_DW: 1,
  EXTERNAL_WATER: 10,
};

export const SPECIES_UNIT = {
  MICROGRAM_LITRE: 1,
  MILIEQUIVALENT_PER_LITER: 2,
  MILIGRAM_PER_LITER: 3,
  PPMV: 4,
};

export const OVERRUN_COMPUTATION = {
  MANNUAL: 0,
  AUTOMATIC: 1,
};

export const EquipmentDefaults = {
  pdExtPiping: 0.1,
  pdIntDistributor: 0.05,
  effluentPressure: 1,
  tankTemperature: 25,
};

// Constants for IX regeneration dose IDs and safety factors(Product Quality Page)
export const IX_REGEN_DOSE_ID = {
  sacSafetyFactor: 5,
  sbaSafetyFactor: 6,
  wacSafetyFactor: 7,
  wbaSafetyFactor: 8,
  wbaOverRun: 9,
  wacOverRun: 11,
};

/**
 * CO2 partial pressure. No unit conversion is required for minPressure and maxPressure as
 * numerically they are the same value, but depending on where you are,
 * the label should reflect user selection back on the units page.
 */

/** Updated the ranges as per Bug 173734 */
export const IX_DEGAS_RANGES = {
  co2Removal: { min: 1, max: 100 },
  co2PartialPressure: { min: 1, max: 10000 },
  co2Concentration: { min: 1, max: 100 },
};

export const tabMenuIds = {
  ixInitialization: 1,
  vesselRegeneration: 2,
  resinSelection: 3,
  regenerationConditions: 4,
  advancedRegeneration: 5,
  equipment: 6,
  productQuality: 7,
};

export const tabMenus = {
  1: "ixInitialization",
  2: "vesselRegeneration",
  3: "resinSelection",
  4: "regenerationConditions",
  5: "advancedRegeneration",
  6: "equipment",
  7: "productQuality",
  8: "existingPlantDescription",
  9: "finalParameterAdjustments",
};

export const baseMenu = t => [
  {
    Id: tabMenuIds.ixInitialization,
    Name: "IXInitialization",
    Value: t("ixMenuPanelStrings.ixInitialization"),
  },
  {
    Id: tabMenuIds.vesselRegeneration,
    Name: "VesselRegeneration",
    Value: t("ixMenuPanelStrings.vesselRegeneration"),
  },
  {
    Id: tabMenuIds.resinSelection,
    Name: "ResinSelection",
    Value: t("ixMenuPanelStrings.resinSelection"),
  },
  {
    Id: tabMenuIds.regenerationConditions,
    Name: "RegenerationConditions",
    Value: t("ixMenuPanelStrings.regenerationConditions"),
  },
  {
    Id: tabMenuIds.advancedRegeneration,
    Name: "AdvancedRegeneration",
    Value: t("ixMenuPanelStrings.advancedRegeneration"),
  },
  {
    Id: tabMenuIds.equipment,
    Name: "Equipment",
    Value: t("ixMenuPanelStrings.equipment"),
  },
  {
    Id: tabMenuIds.productQuality,
    Name: "ProductQuality",
    Value: t("ixMenuPanelStrings.productQuality"),
  },
];

export const additionalIXMenus = t => ({
  existingPlantParameter: {
    Id: 8,
    Name: "ExistingPlant",
    Value: t("ixMenuPanelStrings.existingPlantDescription"),
  },
  finalParameter: {
    Id: 9,
    Name: "FinalParameterAdjustments",
    Value: t("ixMenuPanelStrings.finalParameterAdjustments"),
  },
});
export const ixIonicFormId = {
  hydrogenId: 0,
  sodiumId: 1,
  hydroOxideAndSulphateId: 3,
  chlorineId: 4,
};

export const AdjustmentParameterId = {
  utilizeVesselGeometryId: 1,
  utilizeVesselGeometryIgnoreResinId: 2,
  ignoreVesselGeometryResinVolId: 3,
};

export const ixAdvanceRegenRanges = {
  regenFactor: {
    min: 0,
    max: 100,
  },
  regenFactorMB: {
    min: 50,
    max: 150,
  },
};

export const ixRegenConditionRanges = {
  stepConcDose: {
    min: 0,
    max: 100,
  },
};

export const OVER_ALL_PROCESS_DATA = {
  overallProcessIsOrgScav: 0,
  overallProcessIsSofteningSac: 1,
  overallProcessIsSofteningWac: 2,
  overallProcessIsBrackishSoftening: 3,
  overallProcessIsDealkalizationWac: 4,
  overallProcessIsDealkalizationSba: 5,
  overallProcessIsDealkalizationSoftening: 6,
  overallProcessIsDemineralization: 7,
  overallProcessIsNo3: 8,
  overallProcessIsB: 9,
  overallProcessIsRoPolish: 10,
  overallProcessIsIxPolish: 11,
  overallProcessIsCpp: 12,
};

export const IXInitializationData = {
  0: "organicScavenger",
  1: "softeningSacNa",
  2: "softeningWacH",
  3: "brackishSofteningWacHNa",
  4: "dealkalizationWacH",
  5: "dealkalizationSbaCl",
  6: "dealkalizationWacSofteningSac",
  7: "demineralization",
  8: "no3Removal",
  9: "bRemoval",
  10: "roPermeatePolishing",
  11: "ixDeminPolishing",
  12: "processHohCycle",
  13: "lowPressurePowerHohCycle",
  14: "highPressurePowerHohCycle",
};

export const REGEN_CONDITIONS_DROPDOWN_IDS = {
  CATION_DROPDOWN: "cation_regenerant",
  ANION_DROPDOWN: "anion_regenerant",
  THIRD_DROPDOWN: "third_regenerant",
};

export const NACL_CYCLE_PROCESS_LIST = [
  OVER_ALL_PROCESS_DATA.overallProcessIsOrgScav,
  OVER_ALL_PROCESS_DATA.overallProcessIsSofteningSac,
  OVER_ALL_PROCESS_DATA.overallProcessIsBrackishSoftening,
  OVER_ALL_PROCESS_DATA.overallProcessIsDealkalizationSba,
  OVER_ALL_PROCESS_DATA.overallProcessIsNo3,
];

export const REGEN_PROT_1_SINGLE_RESIN_PROCESS_LIST = [
  OVER_ALL_PROCESS_DATA.overallProcessIsSofteningSac,
  OVER_ALL_PROCESS_DATA.overallProcessIsSofteningWac,
  OVER_ALL_PROCESS_DATA.overallProcessIsDealkalizationWac,
  OVER_ALL_PROCESS_DATA.overallProcessIsNo3,
  OVER_ALL_PROCESS_DATA.overallProcessIsOrgScav,
  OVER_ALL_PROCESS_DATA.overallProcessIsBrackishSoftening,
  OVER_ALL_PROCESS_DATA.overallProcessIsB,
  OVER_ALL_PROCESS_DATA.overallProcessIsDealkalizationSba,
  OVER_ALL_PROCESS_DATA.overallProcessIsIxPolish,
  OVER_ALL_PROCESS_DATA.overallProcessIsRoPolish,
  OVER_ALL_PROCESS_DATA.overallProcessIsCpp,
];

export const REGEN_PROT_1_CATION_RESIN_COUNT_PROCESS_LIST = [
  OVER_ALL_PROCESS_DATA.overallProcessIsDemineralization,
  OVER_ALL_PROCESS_DATA.overallProcessIsDealkalizationSoftening,
];

export const SWELLING_DATA_KEYS_MAPPING = {
  NACL_CYCLE: {
    sold: "srNaClCycleSold",
    regen: "srNaClCycleRegen",
    exhaust: "srNaClCycleExhaust",
  },
  OH_CYCLE: {
    sold: "srHOhCycleSold",
    regen: "srHOhCycleRegen",
    exhaust: "srHOhCycleExhaust",
  },
};

export const CHEMICAL_REGENERANT_ID = {
  hydrochloricAcid: 1,
  sulfuricAcid: 2,
  sodiumChloride: 3,
  sodiumHydroxide: 4,
  sodiumCarbonate: 5,
};

export const DEFAULT_RUN_TIME_VALUE = {
  spaceVelocity: 20,
  lengthOperatingCycle: 10,
};

export const IXSD_PROCESS_ID = {
  softeningSacNa: 1,
  softeningWacH: 2,
  brackishSofteningWacHNa: 3,
  dealkalizationWacH: 4,
  dealkalizationSbaCl: 5,
};

export const IXCP_SUB_PROCESS_ID = {
  processHohCycle: 0,
  lowPressurePowerHohCycle: 1,
  highPressurePowerHohCycle: 2,
};

export const IXCP_ARRANGEMENT_IDS = {
  [RESIN_ID.SAC_SBA_TWO_VESSEL_RESIN_ID]: 1,
  [RESIN_ID.SBA_SAC_SINGLE_CHAMBER_RESIN_ID]: 3,
  [RESIN_ID.SAC_SAC_SBA_TWO_VESSEL_RESIN_ID]: 4,
  [RESIN_ID.SAC_SBA_SAC_THREE_VESSEL_RESIN_ID]: 5,
};

export const FLAG_DESIGN_CATION = {
  NONE: 0,
  WAC: 1,
  SAC: 2,
  WAC_SAC_2V: 3,
  WAC_SAC_LB: 4,
  WAC_SAC_2C: 5,
  SAC_SBA_2C: 8,
  MB: 9,
};

export const RESIN_TO_FLAG_DESIGN_CATION = {
  [RESIN_ID.WAC_RESIN_ID]: FLAG_DESIGN_CATION.WAC,
  [RESIN_ID.SAC_RESIN_ID]: FLAG_DESIGN_CATION.SAC,
  [RESIN_ID.WAC_SAC_TWO_VESSEL_RESIN_ID]: FLAG_DESIGN_CATION.WAC_SAC_2V,
  [RESIN_ID.WAC_SAC_SINGLE_CHAMBER_RESIN_ID]: FLAG_DESIGN_CATION.WAC_SAC_LB,
  [RESIN_ID.WAC_SAC_TWO_CHAMBER_RESIN_ID]: FLAG_DESIGN_CATION.WAC_SAC_2C,
  [RESIN_ID.SBA_SAC_TWO_CHAMBER_RESIN_ID]: FLAG_DESIGN_CATION.SAC_SBA_2C,
  [RESIN_ID.SBA_SAC_SINGLE_CHAMBER_RESIN_ID]: FLAG_DESIGN_CATION.MB,
};

export const FLAG_DESIGN_CATION_TO_RESIN_COUNT = {
  [FLAG_DESIGN_CATION.NONE]: 0,
  [FLAG_DESIGN_CATION.WAC]: 1,
  [FLAG_DESIGN_CATION.SAC]: 1,
  [FLAG_DESIGN_CATION.SAC_SBA_2C]: 1,
  [FLAG_DESIGN_CATION.MB]: 1,
  [FLAG_DESIGN_CATION.WAC_SAC_2V]: 2,
  [FLAG_DESIGN_CATION.WAC_SAC_LB]: 2,
  [FLAG_DESIGN_CATION.WAC_SAC_2C]: 2,
};

// Bug 190676: For IXSD single-resin, the UI stores "product of subsequent section" (2)
// but the calc engine expects "product of this section" (1) since there is no subsequent section.
export const IXSD_BW_SOURCE_TRIGGER_VALUE = 2; // UI dropdown value representing "product water" (subsequent section)
export const IXSD_BW_SOURCE_REMAPPED_VALUE = 1; // Correct calc engine value for IXSD (this section)
